import { ActionTypes as action } from "./action-types";
import peopleService from "../../../api/peopleService";

const actions = {
    async getPeopleList({ commit }) {
        const data = await peopleService.getPeopleList();
        commit(action.GET_PEOPLE_LIST, data);
        return;
    },
    async getUserList({ commit }) {
        const data = await peopleService.getUserList();
        commit(action.GET_USER_LIST, data);
        return;
    },
    async getCachedUserList({ commit, state }, isTenantSwitch = false) {
        if (!state.userList.length || isTenantSwitch) {
            const data = await peopleService.getUserList();
            commit(action.GET_USER_LIST, data);
        }
        return
    },
    async getUpdatedUserList({ commit, state }) {
        const data = await peopleService.getUserList();
        commit(action.GET_USER_LIST, data);
        return
    },
    async getPeopleById({ commit }, id) {
        const data = await peopleService.getPeopleById(id);
        if (data) {
            commit(action.GET_PEOPLE_BY_ID, data);
        }
        return data;
    },
    async createPeople({ dispatch, commit }, data) {
        await peopleService.createPeople(data);
        await dispatch('getPeopleList')
        return;
    },
    async updateUserWithPeople({ dispatch, commit }, data) {
        const result = await peopleService.updatePeople(data);
        await dispatch('getPeopleList')
        return;
    },
    async updatePeople({ dispatch, commit }, data) {
        const result = await peopleService.updatePeople(data);
        // commit(action.GET_PEOPLE_BY_ID, result);
        await dispatch('getPeopleList')
        return;
    },
    async deletePeople({ dispatch, commit }, id) {
        await peopleService.deletePeople(id);
        await dispatch('getPeopleList')
        return;
    },
    async setPeopleOrder({ dispatch, commit }, data) {
        commit(action.SET_PEOPLE_ORDER, data);
        return;
    },
    resetState({ commit }) {
        commit(action.RESET_STATE);
    },
};

export default actions;
